<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-layout row wrap style="page-break-inside: avoid">
		<v-flex d-flex xs1>
			<v-card color="grey lighten-1" class="financial-table-header-color">
				<v-card-text class="text-xs-center">
					<div>
						<strong>
							{{index}}
						</strong>
					</div>

				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs5>
			<v-card color="grey lighten-2" class="financial-table-header-color">
				<v-card-text>
					<b v-if="bold">
						<strong>
							{{label}}
							<v-tooltip bottom v-if="showWarning">
								<template v-slot:activator="{ on }">
									<v-icon color="warning" v-on="on" class="ml-1">
										warning
									</v-icon>
								</template>
								<span>{{ getWarningLabel }}</span>
							</v-tooltip>
						</strong>
					</b>
					<div v-else>
						<strong>
							{{label}}
							<v-tooltip bottom v-if="showWarning">
								<template v-slot:activator="{ on }">
									<v-icon color="warning" v-on="on" class="ml-1">
										warning
									</v-icon>
								</template>
								<span>{{ getWarningLabel }}</span>
							</v-tooltip>
						</strong>
					</div>

				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card color="grey lighten-2">
				<v-card-text style="text-align: right">
					{{fromProject}} {{isPercentage ? " %" : ""}}
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card color="grey lighten-2">
				<v-card-text style="text-align: right">
					{{fromDocument}} {{isPercentage ? " %" : ""}}
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	import {Numbers} from "../../../utils/Numbers";

	export default {
		name: 'financial-summary-row',

		mixins: [Numbers],

		computed: {
			showWarning () {
				if (!this.compare || !['ge', 'le'].includes(this.compare)) return false;
				if(isNaN(this.parseToFloat(this.fromProject)) || isNaN(this.parseToFloat(this.fromDocument))) return false;
				return this.compare === "ge" ? !(this.parseToFloat(this.fromProject) >= this.parseToFloat(this.fromDocument)) :
					!(this.parseToFloat(this.fromProject) <= this.parseToFloat(this.fromDocument));
			},

			getWarningLabel () {
				return this.compare === "ge" ? "Faktycznie poniesione wydatki są większe niż kwota z umowy" :
					"Kwota z umowy jest większa niż faktycznie poniesione wydatki";
			}
		},

		props: {
			isPercentage: {
				type: Boolean,
				default: false,
			},
			index: {},
			label: {},
			fromDocument: {},
			fromProject: {},
			bold: {},
			compare: {
				type: String,
				required: false,
				default: undefined
			}
		}
	};
</script>
<style scoped>
@media print {
	.financial-table-header-color >>> .v-icon {
		color: grey !important;
	}
}
</style>
